import React from 'react';
import { connect } from 'react-redux';

import styles from './styles';
import IconMessagesMessage from '../IconMessagesMessage';
import * as chatSelectors from '../../../chat/app/ChatApp/selectors';

export class IconMessages extends React.PureComponent {
  render() {
    const { unreadSessionMessages } = this.props;
    if (!unreadSessionMessages || unreadSessionMessages.size < 1) return null;

    return (
      <div className="iconMessage" style={styles.container}>
        {unreadSessionMessages.map(session => (
          <IconMessagesMessage key={session.sessionId} sessionId={session.sessionId} message={session.message} />
        ))}
      </div>
    );
  }
}

IconMessages.propTypes = {
  unreadSessionMessages: React.PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

IconMessages.defaultProps = {
  unreadSessionMessages: undefined,
};

export const mapStateToProps = state => {
  return {
    unreadSessionMessages: chatSelectors.getCampaignMessages(state),
  };
};

export default connect(mapStateToProps)(IconMessages);
